import { useState, useEffect, useRef } from 'react'

const getFullscreenElement = () =>
  document.fullscreenElement ||
  document.webkitFullscreenElement ||
  document.mozFullScreenElement ||
  document.msFullscreenElement ||
  null

const Fullscreen = ({ className = 'btn btn-sm d-none d-md-block' }) => {
  const [isMaximized, setIsMaximized] = useState(false)
  const transitionInProgress = useRef(false)

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsMaximized(!!getFullscreenElement())
      transitionInProgress.current = false

      // Components using vh/dvh (calendar, order detail) need a fresh layout
      // after leaving fullscreen in some tablet browsers.
      window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')))
    }

    document.addEventListener('fullscreenchange', handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange)
    document.addEventListener('mozfullscreenchange', handleFullscreenChange)
    document.addEventListener('MSFullscreenChange', handleFullscreenChange)
    handleFullscreenChange()

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange)
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange)
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange)
    }
  }, [])

  const toggleMaximize = async event => {
    if (transitionInProgress.current) return
    transitionInProgress.current = true

    event.currentTarget.blur()
    const el = document.documentElement
    const requestFullscreen =
      el.requestFullscreen ||
      el.webkitRequestFullscreen ||
      el.mozRequestFullScreen ||
      el.msRequestFullscreen
    const exitFullscreen =
      document.exitFullscreen ||
      document.webkitExitFullscreen ||
      document.mozCancelFullScreen ||
      document.msExitFullscreen

    try {
      if (!getFullscreenElement() && requestFullscreen) {
        await Promise.resolve(requestFullscreen.call(el))
      } else if (getFullscreenElement() && exitFullscreen) {
        await Promise.resolve(exitFullscreen.call(document))
      }
    } catch (error) {
      console.error('Fullscreen se nepodařilo přepnout:', error)
    } finally {
      // A rejected request does not fire fullscreenchange.
      setIsMaximized(!!getFullscreenElement())
      transitionInProgress.current = false
    }
  }

  return (
    <button
      onClick={toggleMaximize}
      type="button"
      data-fullscreen-toggle
      title={isMaximized ? 'Zmenšit okno' : 'Zvětšit okno'}
      className={className}
    >
      {isMaximized ? <i className="bi bi-fullscreen-exit"></i> : <i className="bi bi-fullscreen"></i>}
    </button>
  )
}

export default Fullscreen
